var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _radialGradient, _feGaussianBlur, _g, _path, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoadingIndicator(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 10 160 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4691"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#666",
      stopOpacity: 1
    },
    offset: 0,
    id: "stop4687"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#666",
      stopOpacity: 0
    },
    offset: 1,
    id: "stop4689"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient4691",
    id: "linearGradient4693",
    x1: 144.73973,
    y1: 139.55252,
    x2: 114.53898,
    y2: 114.74477,
    gradientUnits: "userSpaceOnUse"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4707"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#999",
      stopOpacity: 1
    },
    offset: 0,
    id: "stop4703"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ccc",
      stopOpacity: 1
    },
    offset: 1,
    id: "stop4705"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient4707",
    id: "linearGradient4709",
    x1: 134.04364,
    y1: 121.66577,
    x2: 126.94286,
    y2: 114.83465,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient4691",
    id: "linearGradient4693",
    x1: 144.73973,
    y1: 139.55252,
    x2: 114.53898,
    y2: 114.74477,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient4691",
    id: "linearGradient4693",
    x1: 144.73973,
    y1: 139.55252,
    x2: 114.53898,
    y2: 114.74477,
    gradientUnits: "userSpaceOnUse"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4699"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#808080",
      stopOpacity: 1
    },
    offset: 0,
    id: "stop4695"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#808080",
      stopOpacity: 0
    },
    offset: 1,
    id: "stop4697"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient4699",
    id: "linearGradient4701",
    x1: 155.97514,
    y1: 120.58717,
    x2: 148.6946,
    y2: 98.206253,
    gradientUnits: "userSpaceOnUse"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4741"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f00",
      stopOpacity: 1
    },
    offset: 0,
    id: "stop4737"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ff0",
      stopOpacity: 1
    },
    offset: 1,
    id: "stop4739"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient4741",
    id: "linearGradient4743",
    x1: 129.94109,
    y1: 115.54415,
    x2: 130.81287,
    y2: 100.55452,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1.2565169,0,0,1.5096821,-32.912832,-56.821451)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4640"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#666",
      stopOpacity: 1
    },
    offset: 0,
    id: "stop4636"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ccc",
      stopOpacity: 1
    },
    offset: 1,
    id: "stop4638"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4570"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop4566",
    offset: 0,
    stopColor: "#f95"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop4568",
    offset: 1,
    stopColor: "#d45500"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4504"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop4500",
    offset: 0,
    stopColor: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop4502",
    offset: 1,
    stopColor: "#1a1a1a"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "translate(66.644 -46.734)",
    gradientUnits: "userSpaceOnUse",
    y2: 81.8,
    x2: 11.5,
    y1: 53,
    x1: 13.2,
    id: "linearGradient4506",
    xlinkHref: "#linearGradient4504"
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1.29475 -.23472 .1288 .71045 -27.262 35.607)",
    r: 61.4,
    fy: 74.6,
    fx: 65.6,
    cy: 74.6,
    cx: 65.6,
    id: "radialGradient4574",
    xlinkHref: "#linearGradient4570"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4644",
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feGaussianBlur || (_feGaussianBlur = /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur4642",
    result: "blur",
    stdDeviation: "8 2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bomb",
    transform: "translate(13.005 -22.938)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "path4496",
    cx: 59,
    cy: 76.2,
    r: 38.1,
    stroke: "#000",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(21.624)",
    d: "M106.7 24.6C107.7 31.3 96 37 82.5 37c-13.3 0-25-5.6-24-12.4C59 18 69.4 12 82.8 12c13.2 0 22.7 5.8 23.7 12.6z",
    id: "path4498",
    fill: "url(#linearGradient4506)",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7 55.3c-2.2 2.5-3.7 5.5-5 9.6 1.6 0 3.3.4 5 .8 1.3-3 3-5.8 5-8.4l-5-2zm6.6 2.7c-2.2 2.6-4 5.3-5.2 8.2 2 .6 4 1.3 6 2.3 1.7-3.5 3.8-6.4 6-9-2.7-.3-4.8-1-6.7-1.5zM26 66.3c-1.2 4-2 8.4-2.3 11.7 1.2-.4 3-.5 5-.3C29 74 30 70.4 31.2 67c-1.6-.3-3.3-.6-5-.7zm6.5 1c-1.3 3.4-2 7-2.3 10.6 2.6.3 5 1.2 6.6 2.2 0-4 .7-7.5 1.8-10.5-2-1-4-1.7-6-2.3z",
    id: "path4526",
    fill: "#b3b3b3",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "path4539",
    cx: 95.4,
    cy: -6.4,
    rx: 6.9,
    ry: 4.4,
    transform: "matrix(.82332 .56758 -.0598 .9982 0 0)",
    fill: "#333",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6 35.6c.4-.7 3.2 0 5.3 1.6 2 1.5 3.5 4 3 4.3l-5 7.3c-.6.7-3.8-.5-5.3-1.5-1.4-1-3.8-3.6-3.2-4.5z",
    id: "rect4536",
    strokeWidth: 0.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6 37.8c1 1.7 5.5 4.2 6.7 3.8",
    id: "path4541",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#333",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fuse",
    strokeDasharray: "120, 130",
    d: "M96 15.2c24.7-36 60 6.8 47.4 66.6",
    fill: "none",
    stroke: "#333",
    strokeWidth: 2.6,
    strokeLinecap: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "light"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fire",
    strokeDasharray: "1, 5",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#fc0",
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4600",
    d: "M143.7 81.5 l 9 10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4600",
    d: "M143.7 81.5 l 9 -9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4600",
    d: "M143.7 81.5 l -9 9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4600",
    d: "M143.7 81.5 l -10 -9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4600",
    d: "M143.7 81.5 l 0.1-10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4600",
    d: "M143.7 81.5 l 10 -1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4600",
    d: "M143.7 81.5 l -10 1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4600",
    d: "M143.7 81.5 l 0.2 12 "
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4600",
    d: "M143.7 81.5 l 10 5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4600",
    d: "M143.7 81.5 l 10 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4600",
    d: "M143.7 81.5 l 10 -5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4600",
    d: "M143.7 81.5 l -5 10"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path4604",
    cx: 143.7,
    cy: 81,
    r: 2.5,
    fill: "#fc0"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingIndicator);
export default __webpack_public_path__ + "static/media/loadingIndicator.48526ebd.svg";
export { ForwardRef as ReactComponent };